import { useNotification } from '../../../hooks'
import { Notification } from '../Notification'

import * as styles from './NotificationContainer.module.css'

function NotificationContainer({ children }) {
  const { queue: notifications } = useNotification()

  return (
    <>
      {children}
      {notifications.length > 0 ? (
        <div className={styles.notificationsBox}>
          {notifications.map(notification => (
            <Notification {...notification} key={notification.id} />
          ))}
        </div>
      ) : null}
    </>
  )
}

export default NotificationContainer
